import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from 'react';
const MapIcon = _ref => {
  let {
      size = "13",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    viewBox: "0 0 22 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M20.2752 0.141667C20.42 0.260378 20.5039 0.43776 20.5039 0.625005V18.125C20.5039 18.4229 20.2936 18.6794 20.0015 18.7379L13.7515 19.9879C13.6706 20.0041 13.5872 20.0041 13.5063 19.9879L7.37891 18.7624L1.25148 19.9879C1.06787 20.0246 0.877468 19.9771 0.732663 19.8583C0.587858 19.7396 0.503906 19.5623 0.503906 19.375V1.87501C0.503906 1.57708 0.714194 1.32057 1.00633 1.26214L7.25633 0.0121425C7.33725 -0.00404028 7.42057 -0.00404028 7.50148 0.0121425L13.6289 1.23763L19.7563 0.0121425C19.9399 -0.0245794 20.1303 0.0229548 20.2752 0.141667ZM13.0039 2.38738L8.00391 1.38738V17.6126L13.0039 18.6126V2.38738ZM14.2539 18.6126L19.2539 17.6126V1.38738L14.2539 2.38738V18.6126ZM6.75391 17.6126V1.38738L1.75391 2.38738V18.6126L6.75391 17.6126Z",
    fill: color
  }));
};
export default MapIcon;